import type { AppDispatch, RootState } from "store";
import websocketService from "services/websocket";
import { selectIndicator, removeIndicator, resetIndicators, updateIndicatorSettings, toggleIndicatorVisibility, toggleFavorite } from "./IndicatorsSlice";
import type { IndicatorName } from "./types";

type Thunk = (dispatch: AppDispatch, getState: () => RootState) => void;

const syncToServer = (_dispatch: AppDispatch, getState: () => RootState): void => {
  const { instances, favorites } = getState().indicators;
  websocketService.saveUserSettings({ indicator_instances: instances, indicator_favorites: favorites });
};

export const addIndicator = (name: IndicatorName): Thunk => (dispatch, getState) => {
  dispatch(selectIndicator(name));
  syncToServer(dispatch, getState);
};

export const removeIndicatorThunk = (id: string): Thunk => (dispatch, getState) => {
  dispatch(removeIndicator(id));
  syncToServer(dispatch, getState);
};

export const clearIndicators = (): Thunk => (dispatch, getState) => {
  dispatch(resetIndicators());
  syncToServer(dispatch, getState);
};

export const saveIndicatorSettingsThunk = (_id: string): Thunk => (_dispatch, getState) => {
  syncToServer(_dispatch, getState);
};

export const toggleIndicatorVisibilityThunk = (id: string): Thunk => (dispatch, getState) => {
  dispatch(toggleIndicatorVisibility(id));
  syncToServer(dispatch, getState);
};

export const toggleFavoriteIndicator = (name: IndicatorName): Thunk => (dispatch, getState) => {
  dispatch(toggleFavorite(name));
  syncToServer(dispatch, getState);
};
